module.exports = __webpack_public_path__ + "media/images/flags/1x1/sgs-419dfbc9e85ec7bc582cde3da752791a.svg";